import React, { createElement } from "react";
import { connect } from "react-redux";
import { MenuItemLink, getResources, Responsive, translate } from "react-admin";
import { withRouter } from "react-router-dom";
import {
    getUserCompanyRole,
    getPolicies,
    getIsImpersonating
} from "../common/authClient";
import AssignmentIcon from "@material-ui/icons/Assignment";
import StorageIcon from "@material-ui/icons/Storage";
import PeopleIcon from "@material-ui/icons/People";
import {
    POLICY_ROLE_MAPPINGS,
    POLICY_CONSOLE,
    POLICY_ROLES
} from "../common/rolesManagement";

// import LabelIcon from "@material-ui/icons/Label";

const MyMenuComponent = ({ translate, resources, onMenuClick, logout }) => (
    <div>
        {resources.map(resource => {
            if (resource.icon) {
                const policies = getPolicies(getUserCompanyRole());
                if (
                    resource.name === "role-mappings" &&
                    policies &&
                    !policies.includes(POLICY_ROLE_MAPPINGS.READ)
                ) {
                    return null;
                } else if (resource.name === "customers-mappings") {
                    return null;
                }
                if (resource.name === "profile") {
                    return null;
                }
                return (
                    <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={translate(
                            `resources.${resource.name}.namePlural`
                        )}
                        leftIcon={createElement(resource.icon)}
                        onClick={onMenuClick}
                    />
                );
            } else {
                return null;
            }
        })}
        {/* <MenuItemLink
            to="/custom-rougetRolePoliciese"
            primaryText="MigetRolePoliciescellaneous"
            leftIcon={<LabegetRolePoliciesIcon />}
            onClick={onMenugetRolePolicieslick}
        /> */}
        {getPolicies(getUserCompanyRole()) &&
            getPolicies(getUserCompanyRole()).includes(
                POLICY_CONSOLE.HIGH_PRIVILEGE_FUNCTIONS
            ) && (
                // Modulo migrato su Polar (TSXCL-7996): link full-page all'app Polar
                <a
                    href="/polar/configdatabase"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 16px",
                        textDecoration: "none",
                        color: "rgba(0, 0, 0, 0.87)",
                        cursor: "pointer"
                    }}
                    onClick={onMenuClick}
                >
                    <StorageIcon
                        style={{
                            marginRight: 16,
                            color: "rgba(0, 0, 0, 0.54)"
                        }}
                    />
                    {translate("resources.configdatabase.namePlural")}
                </a>
            )}
        {(getIsImpersonating() ||
            (getPolicies(getUserCompanyRole()) &&
                getPolicies(getUserCompanyRole()).includes(
                    POLICY_CONSOLE.HIGH_PRIVILEGE_FUNCTIONS
                ) &&
                getPolicies(getUserCompanyRole()).includes(
                    POLICY_ROLES.IMPERSONATE
                ))) && (
            // Modulo migrato su Polar (TSXCL-7998): link full-page all'app Polar
            <a
                href="/polar/roleswitching"
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                    textDecoration: "none",
                    color: "rgba(0, 0, 0, 0.87)",
                    cursor: "pointer"
                }}
                onClick={onMenuClick}
            >
                <PeopleIcon
                    style={{
                        marginRight: 16,
                        color: "rgba(0, 0, 0, 0.54)"
                    }}
                />
                {translate("resources.roleswitching.namePlural")}
            </a>
        )}
        {getPolicies(getUserCompanyRole()) &&
            getPolicies(getUserCompanyRole()).includes(
                POLICY_CONSOLE.HIGH_PRIVILEGE_FUNCTIONS
            ) && (
                // Modulo migrato su Polar (TSXCL-7806): link full-page all'app Polar
                <a
                    href="/polar/logs"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 16px",
                        textDecoration: "none",
                        color: "rgba(0, 0, 0, 0.87)",
                        cursor: "pointer"
                    }}
                    onClick={onMenuClick}
                >
                    <AssignmentIcon
                        style={{
                            marginRight: 16,
                            color: "rgba(0, 0, 0, 0.54)"
                        }}
                    />
                    {translate("resources.logs.namePlural")}
                </a>
            )}
        <Responsive
            small={logout}
            medium={null} // Pass null to render nothing on larger devices
        />
    </div>
);

const mapStateToProps = state => ({
    resources: getResources(state)
});

const MyMenu = translate(withRouter(connect(mapStateToProps)(MyMenuComponent)));

export default MyMenu;



// WEBPACK FOOTER //
// ./src/components/MyMenu.js